export const boat = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/48.svg';

export const city = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/101.svg';

export const food = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/103.svg';

export const hopOnOff = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/9.svg';

export const localPin = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/21.svg';

export const nature = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/35.svg';

export const sightseeing = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/2.svg';

export const sun = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/172.svg';

export const tickets = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/123.svg';

export const transport = 'https://cdn.getyourguide.com/tf/assets/static/categories-icons/152.svg';
